import React, { useState, useEffect } from 'react';
import Sidebar from './components/Sidebar';
import HomePage from './components/HomePage';
import ResumePage from './components/ResumePage';
import ResearchPage from './components/ResearchPage';
import UsedCarsPage from './components/UsedCarsPage';
import CouponsPage from './components/CouponsPage';
import BankMarketingPage from './components/BankMarketingPage';
import './App.css';
import LandmarksPage from './components/LandmarksPage';

function App() {
  const [currentPath, setCurrentPath] = useState<string>('/');
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(window.innerWidth > 768);

  // Close sidebar when navigating on mobile
  const handleNavigate = (path: string) => {
    setCurrentPath(path);
    if (window.innerWidth <= 768) {
      setIsSidebarOpen(false);
    }
  };

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Update sidebar state on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth > 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Simple routing based on currentPath
  const renderContent = () => {
    switch (currentPath) {
      case '/resume':
        return <ResumePage />;
      case '/used-cars':
        return <UsedCarsPage />;
      case '/coupons':
        return <CouponsPage />;
      case '/bank-marketing':
        return <BankMarketingPage />;
      case '/research':
        return <ResearchPage />;
      case '/landmarks':
        return <LandmarksPage />;
      case '/':
      default:
        return <HomePage />;
    }
  };

  return (
    <div className="App">
      <Sidebar
        onNavigate={handleNavigate}
        activePath={currentPath}
        isOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />
      <div className={`content-with-sidebar ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="mobile-toggle-button" onClick={toggleSidebar}>
          <span className="menu-icon">{isSidebarOpen ? '✕' : '☰'}</span>
        </div>
        {renderContent()}
      </div>
    </div>
  );
}

export default App;
